const i18n = {
  'en-US': {
    'createCorp.form.title': 'Create new corporation',
    'createCorp.form.subtitle': 'Do you want to create a new corporation?',
    'createCorp.form.create.new': 'I am the owner of the corporation',
    'createCorp.form.not.create': 'I am not the owner of the corporation',
    'createCorp.form.corp_full_name.placeholder': 'Please enter corporation name',
    'createCorp.form.corp_full_name.errMsg': 'Corporation name cannot be empty',
    'createCorp.form.identifier.errMsg': 'Account must be a phone or email',
    'createCorp.form.verify_code.errMsg': 'Verify code must be 6 digits',
    'createCorp.form.getVerifyCode.errMsg': 'Get verify code error, please refresh and try again',
    'createCorp.form.register.errMsg': 'Register error, please refresh and try again',
    'createCorp.form.identifier.placeholder': 'Please enter owner phone or email',
    'createCorp.form.notFoundUserID.errMsg': 'UserID not found, please login again',
    'createCorp.form.verify_code.placeholder': 'Please enter verify code',
    'createCorp.form.getVerifyCode': 'Get verify code',
    'createCorp.form.login': 'Login',
    'createCorp.form.create': 'Create corporation'
  },
  'zh-CN': {
    'createCorp.form.title': '创建新企业',
    'createCorp.form.subtitle': '您还没有加入任何企业，是否要创建新企业？',
    'createCorp.form.create.new': '我要创建新企业',
    'createCorp.form.not.create': '我不打算创建新企业',
    'createCorp.form.corp_full_name.placeholder': '请输入企业名称',
    'createCorp.form.corp_full_name.errMsg': '企业名称不能为空',
    'createCorp.form.identifier.errMsg': '账号必须为手机号或者邮箱',
    'createCorp.form.verify_code.errMsg': '验证码必须为6位数字',
    'createCorp.form.getVerifyCode.errMsg': '获取验证码出错，请刷新重试',
    'createCorp.form.register.errMsg': '注册出错，请刷新重试',
    'createCorp.form.identifier.placeholder': '请输入企业负责人的手机号码或者邮箱',
    'createCorp.form.notFoundUserID.errMsg': '用户ID未找到，请重新登录',
    'createCorp.form.verify_code.placeholder': '请输入验证码',
    'createCorp.form.getVerifyCode': '获取验证码',
    'createCorp.form.login': '登录',
    'createCorp.form.create': '创建企业'
  }
};
export default i18n;